import { Container, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faGoogle,
  faLinkedinIn,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  appSetup,
  getAllCategories,
  SocialLink,
} from "../../features/master/masterSlice";
import { useEffect } from "react";
import { getGroupByProduct } from "../../features/products/productsSlice";
import AOS from "aos";
import "aos/dist/aos.css";
import ScrollAnimation from "react-animate-on-scroll";

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    // first navigate to Categories page
    dispatch(getGroupByProduct({ p_category_id: id }));
    // Wait a bit to let the Categories component mount
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100); // tweak delay if needed
    navigate(`/categories?category_id=${id}`, { state: { scrollToId: id } });
    // navigate(`/categories?category_id=${id}`);
  };

  const category = useSelector((state) => state.master.categories);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const sociallink = useSelector((state) => state.master.social_link);

  useEffect(() => {
    dispatch(SocialLink());
  }, [dispatch]);

  const isSignin = useSelector((state) => state.auth.is_signin);

  const app_setup = useSelector((state) => state.master.app_setup);

  const topScroll = () => {
 
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
 
};

  // useEffect(() => {
  //   dispatch(appSetup());
  // }, [dispatch]);

  return (
    <footer className="Footer">
      {/* <ScrollAnimation 
      // animateIn={"fadeInRight"}
      > */}

      <div className="container">
        <Row>
          {/* Logo */}
          <Col lg={3} md={6} sm={6} xs={12} className="footer-brand">
            <Link to="/">
              <div className="logo_holder">
                <img
                  src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                  className="logo_img"
                  alt="Logo"
                />
              </div>
            </Link>

            <div className="social-icons">
              {sociallink?.map((val) => (
                <a
                  href={val?.url}
                  className="social-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                  key={val?.id || val?.url}
                >
                  <img
                    src={process.env.REACT_APP_IMG_URL + val?.image}
                    className="social_icon_img"
                    alt="Social"
                  />
                </a>
              ))}
            </div>
          </Col>

          {/* Quick Links */}
          <Col lg={3} md={6} sm={6} xs={6} className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/" onClick={topScroll}>
                  <p>Home</p>
                </Link>
              </li>
              <li>
                <Link to="/about-us" onClick={topScroll}>
                  <p>About Us</p>
                </Link>
              </li>
              <li>
                <Link to="/categories" onClick={topScroll}>
                  <p>Category</p>
                </Link>
              </li>
              <li>
                <Link to="/blog">
                  <p>Blog</p>
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={topScroll}>
                  <p>Contact Us</p>
                </Link>
              </li>
            </ul>
          </Col>

          {/* Policies & Account */}
          <Col lg={3} md={6} sm={6} xs={6} className="footer-links">
            <h3>Useful Links</h3>
            <ul>
              {isSignin && (
                <>
                  <li>
                    <Link to="/wallet" onClick={topScroll}>
                      <p>Wallet</p>
                    </Link>
                  </li>

                  <li>
                    <Link to="/wishlist" onClick={topScroll}>
                      <p>Your Wishlist</p>
                    </Link>
                  </li>
                </>
              )}
              <li>
                <Link to="/faqs" onClick={topScroll}>
                  <p>FAQs</p>
                </Link>
              </li>
              <li>
                <Link to="/terms" onClick={topScroll}> 
                  <p>Terms & Conditions</p>
                </Link>
              </li>
              <li>
                <Link to="/privacy" onClick={topScroll}>
                  <p>Privacy Policy</p>
                </Link>
              </li>
              <li>
                <Link to="/shipping" onClick={topScroll}>
                  <p>Shipping Policy</p>
                </Link>
              </li>
              <li>
                <Link to="/exchange" onClick={topScroll}>
                  <p>Return & Exchange Policy</p>
                </Link>
              </li>

              {isSignin && (
                <li>
                  <Link to="/account" onClick={topScroll}>
                    <p>Your Account</p>
                  </Link>
                </li>
              )}
            </ul>
          </Col>

          {/* Contact */}
          <Col lg={3} md={6} sm={12} xs={12} className="footer-links">
            <h3>Get in Touch</h3>

            <div className="contact-section">
              <h4>Customer Support</h4>
              <Link to={`mailto:${app_setup?.email}`} target="_blank">
                <p>Email: {app_setup?.email}</p>
              </Link>
              <Link to={`tel:${app_setup?.contact_no}`} target="_blank">
                <p>Phone: {app_setup?.contact_no}</p>
              </Link>
            </div>

            <div className="contact-section">
              <h4>Corporate Queries</h4>
              <Link to={`tel:${app_setup?.alt_contact_no}`} target="_blank">
                <p>Phone: {app_setup?.alt_contact_no}</p>
              </Link>
            </div>

            {/* Uncomment if needed */}
            {/* 
      <div className="contact-section">
        <h4>Address</h4>
        <p><b>The Maa Edit</b></p>
        <p>{app_setup?.address}</p>
      </div>
      */}
          </Col>
        </Row>
      </div>

      <Row className="me-0 ms-0">
        <Col className="copyright">
          <p>
            ©2026 The Maa Edit. All Rights Reserved | Developed by{" "}
            <Link to={"https://profcymaglobal.com/"} target="_blank">
              Profcyma Solutions Pvt Ltd
            </Link>
          </p>
        </Col>
      </Row>

      {/* </ScrollAnimation> */}
    </footer>
  );
};

export default Footer;
